import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit, Input } from '@angular/core';



@Component({
  selector: 'app-student-communications',
  templateUrl: './student-communications.component.html',
  styleUrls: ['./student-communications.component.scss']
})
export class StudentCommunicationsComponent implements OnInit {
  @Input() dynamicStudentUserId: number;
  @Input() studentPartnerId: number;
  messages: any[];
  currentPage = 1; // variable to store current page
  totalItems = 0; // variable to store total items
  maxSize = 5; // variable to store max size
  pageShow = false; // variable to check if pagination to be shown or not
  showSort = [false];
  isLoading = false;
  pageSize = 15;
  pageNo = 1;
  studentName: string;
  studentUserId: number;
  showFullView = false;
  chatData: any;
  show: number;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
  ) { }

  ngOnInit() {
    const localStorageData = this._commonAuthService.getLoginData();
    this.studentUserId = parseInt(localStorageData.userId);
    this.studentName = localStorageData.firstName + ' ' + localStorageData.lastName;
    this.getMessages();
  }

  getMessages() {
    this.isLoading = true;

    const inputJson = {
      studentUserId: this.dynamicStudentUserId ? this.dynamicStudentUserId : this.studentUserId,

    }; 
    this._commonRequestResponseService.post('student/GetChatArchive', inputJson)
      .subscribe(
        (communicationDataJson: any) => {
          this.isLoading = false;
          this.messages = communicationDataJson.chatData;
          this.totalItems = communicationDataJson.total;

        },
        () => {
          this.isLoading = false;
          this.messages = [];
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  showCommunicationThread(item: any, index: number) {
    this.show = index;
    this.showFullView = !this.showFullView;
    this.chatData = item;
  }
}
